<template>
  <base-modal name="unlockDeviceModal" width="318">
    <template #body>
      <div class="mt-40 flex flex-col justify-center items-center">
        <div class="w-102 h-102 bg-warning05 rounded-full flex items-center justify-center">
          <lock-icon width="50" height="50" color="#FFCC00" />
        </div>
        <div class="my-50">
          <h6 class="font-semibold text-18 text-title text-center">
            <span class="block">
              {{ $t('unlocking_device_confirmation', { device: device }) }}
            </span>
          </h6>
        </div>
      </div>
    </template>
    <template #action>
      <div class="grid grid-cols-2 gap-x-20">
        <base-button buttonType="cancel" width="120" height="50" @click.native="closeModal">
          <template #text>
            <span class="text-14">
              {{ $t('cancel') }}
            </span>
          </template>
        </base-button>
        <base-button
          :disabled="disabledButton"
          buttonType="warning-opacity"
          width="120"
          height="50"
          @click.native="unlockDeviceConfirmation"
        >
          <template #text>
            <span class="text-14">
              {{ $t('unlock') }}
            </span>
          </template>
          <template #icon>
            <base-loading />
          </template>
        </base-button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import LockIcon from '@/assets/icons/vue/Lock.vue';
import deleteFull from '@/assets/icons/svg/Delete_Full.svg';
import BaseModal from './BaseModal.vue';

export default {
  name: 'unlockDeviceModal',
  components: {
    BaseModal,
    BaseButton,
    BaseLoading,
    LockIcon,
  },
  props: {
    device: {
      type: String,
      default: '',
    },
    disabledButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deleteFullIcon: deleteFull,
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch('modal/close', 'unlockDeviceModal');
    },
    unlockDeviceConfirmation() {
      this.$emit('unlockDeviceConfirmation');
    },
  },
};
</script>
